/**
 * Truncate text to a given length, adding ellipsis if exceeded
 *
 * @param {string} text - The text to truncate
 * @param {number} length - Maximum character length
 * @returns {string} Truncated text with "..." suffix, or original if within limit
 */
export default function truncateText(text, length) {
  if (!text) return '';
  return text.length > length ? `${text.substring(0, length)}...` : text;
}
